module.exports = __webpack_public_path__ + "img/slant.8bd4e5d2.svg";